import { createTheme } from '@mui/material/styles';

// CoinFox theme with orange accents - using a lighter dark theme for better visibility
const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#ff4900', // Primary accent color
            light: '#ff6933',
            dark: '#cc3a00',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#e0e0e0',
            light: '#ffd55f',
            dark: '#d6a800',
            contrastText: '#212529',
        },
        background: {
            default: '#151515', // Background Color
            paper: '#0D0D0D', // Content Background Color
        },
        text: {
            primary: '#FFFFFF', // Headings Color - Pure white for better contrast
            secondary: '#FFFFFF', // Body Text Color - Now pure white for maximum contrast
        },
        error: {
            main: '#ef2323', // Loss BG Color
            light: '#f15858',
            dark: '#c51d1d',
            contrastText: '#e0e0e0', // NEW Loss Light Text Color
        },
        warning: {
            main: '#ffca27', // Sunny Yellow
            contrastText: '#212529',
        },
        info: {
            main: '#6c757d', // Gunmetal Grey
            contrastText: '#FFFFFF',
        },
        success: {
            main: '#28A745', // Profit Text Color
            light: '#23ef37', // Profit BG Color
            dark: '#1E7E34', // Profit Dark Text Color
            contrastText: '#FFFFFF',
        },
        divider: '#333333', // Main Divider Line Color
        grey: {
            50: '#F8F9FA',
            100: '#E9ECEF',
            200: '#d1d5db',
            300: '#A0A0A0', // Alternate Text Color
            400: '#6c757d', // Gunmetal Grey
            500: '#495057',
            600: '#343A40',
            700: '#212529',
            800: '#151515',
            900: '#0D0D0D',
            A100: '#252525', // Alternate Content Background Color
            A200: '#2a2a2a', // Secondary Divider Line Color
            A400: '#333333', // Content Border Color
            A700: '#111111', // Dark Grey
        },
    },
    typography: {
        fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
        fontWeightRegular: 'bold',
        h1: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 700,
            color: '#FFFFFF', // Headings Color
        },
        h2: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 700,
            color: '#FFFFFF', // Headings Color
        },
        h3: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 700,
            color: '#FFFFFF', // Headings Color
        },
        h4: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            color: '#FFFFFF', // Headings Color
        },
        h5: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            color: '#FFFFFF', // Headings Color
        },
        h6: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            color: '#FFFFFF', // Headings Color
        },
        subtitle1: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 'bold',
            color: '#FFFFFF', // Body Text Color - Pure white for maximum contrast
        },
        subtitle2: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 'bold',
            color: '#FFFFFF', // Body Text Color - Pure white for maximum contrast
        },
        body1: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: '0.9rem',
            lineHeight: 1.5,
            fontWeight: 'bold',
            color: '#FFFFFF', // Body Text Color - Pure white for maximum contrast
        },
        body2: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: '0.875rem',
            lineHeight: 1.5,
            fontWeight: 'bold',
            color: '#FFFFFF', // Body Text Color - Pure white for maximum contrast
        },
        button: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            textTransform: 'none',
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiTooltip: {
  defaultProps: {
    enterTouchDelay: 0,
    leaveTouchDelay: 2500,
    disableTouchListener: false,
    disableHoverListener: false,
    disableFocusListener: false,
    PopperProps: {
      modifiers: [
        {
          name: 'preventOverflow',
          enabled: true,
          options: {
            boundary: 'viewport',
            padding: 8,
          },
        },
        {
          name: 'flip',
          enabled: true,
        },
      ],
    },
  },
  styleOverrides: {
    tooltip: ({ theme }) => ({
      maxWidth: 220, // Default for desktop
      [theme.breakpoints.down('sm')]: {
        maxWidth: '90vw',
        whiteSpace: 'pre-line',
        wordBreak: 'break-word',
      },
    }),
  },
},
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '8px 16px',
                    fontWeight: 600,
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
                    },
                },
                outlined: {
                    borderWidth: 2,
                    '&:hover': {
                        borderWidth: 2,
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#333333', // Content Border Color
                        },
                        '&:hover fieldset': {
                            borderColor: '#A0A0A0', // Alternate Text Color
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#ff4900', // Primary accent color
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#A0A0A0', // Alternate Text Color
                    },
                    '& .MuiInputBase-input': {
                        color: '#FFFFFF', // Body Text Color - Pure white for maximum contrast
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0D0D0D', // Content Background Color
                    borderRadius: 12,
                    boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.2)',
                    border: '1px solid #333333', // Content Border Color
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0D0D0D', // Content Background Color
                    '--Paper-overlay': 'none !important', // Remove the default overlay globally
                    '&.MuiMenu-paper, &.MuiPopover-paper, &.MuiPickersPopper-paper': {
                        backgroundColor: '#0D0D0D', // Content Background Color
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#151515', // Background Color
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.2)',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#ff4900', // Primary accent color
                    '&:hover': {
                        color: '#ff6933', // Primary light
                    },
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: '#333333', // Main Divider Line Color
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 8,
                    border: '1px solid',
                    borderColor: '#333333', // Content Border Color
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#0D0D0D', // Content Background Color
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: 'rgba(255, 73, 0, 0.08)', // Primary color with opacity
                    },
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(255, 73, 0, 0.12)', // Primary color with opacity
                        '&:hover': {
                            backgroundColor: 'rgba(255, 73, 0, 0.16)', // Primary color with opacity
                        },
                    },
                },
            },
        },
        MuiPopover: {
            defaultProps: {
                container: document.body,
            },
            styleOverrides: {
                paper: {
                    borderRadius: 8,
                    border: '1px solid',
                    borderColor: '#333333', // Content Border Color
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#0D0D0D', // Content Background Color
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0D0D0D', // Content Background Color
                },
            },
        },

        MuiAutocomplete: {
            styleOverrides: {
                paper: {
                    borderRadius: 8,
                    border: '1px solid',
                    borderColor: '#333333', // Content Border Color
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#0D0D0D', // Content Background Color
                },
                listbox: {
                    padding: '4px',
                    backgroundColor: '#0D0D0D', // Content Background Color
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(51, 51, 51, 0.1)',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(255, 255, 255, 0.4)',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.6)',
                        },
                    },
                },
                option: {
                    padding: '8px 10px',
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 73, 0, 0.08)', // Primary color with opacity
                    },
                    '&.Mui-focused': {
                        backgroundColor: 'rgba(255, 73, 0, 0.12)', // Primary color with opacity
                    },
                },
                popper: {
                    backgroundColor: '#0D0D0D', // Content Background Color
                },
            },
        },
    },
});

// Light theme version with the new color palette
const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#ff4900', // Primary accent color
            light: '#ff6933',
            dark: '#cc3a00',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#e0e0e0',
            light: '#ffd55f',
            dark: '#d6a800',
            contrastText: '#212529',
        },
        background: {
            default: '#F8F9FA', // Background Color
            paper: '#FFFFFF', // Content Background Color
        },
        text: {
            primary: '#212529', // Headings Color
            secondary: '#343A40', // Body Text Color
        },
        error: {
            main: '#ef2323', // Loss Text Color
            light: '#f15858',
            dark: '#c51d1d',
            contrastText: '#ffffff', // Loss Dark Text Color -> NEW Loss Light Text Color
        },
        warning: {
            main: '#ffca27', // Sunny Yellow
            contrastText: '#212529',
        },
        info: {
            main: '#6c757d', // Gunmetal Grey
            contrastText: '#FFFFFF',
        },
        success: {
            main: '#28A745', // Profit Text Color
            light: '#23ef37', // Profit BG Color
            dark: '#1E7E34', // Profit Dark Text Color
            contrastText: '#FFFFFF',
        },
        divider: '#d1d5db', // Main Divider Line Color
        grey: {
            50: '#F8F9FA',
            100: '#E9ECEF',
            200: '#d1d5db',
            300: '#6C757D', // Alternate Text Color
            400: '#6c757d', // Gunmetal Grey
            500: '#495057',
            600: '#343A40',
            700: '#212529',
            800: '#151515',
            900: '#0D0D0D',
            A100: '#E9ECEF', // Alternate Content Background Color
            A200: '#e9ecef', // Secondary Divider Line Color
            A400: '#D1D5DB', // Content Border Color
            A700: '#F8F9FA', // Light Grey
        },
    },
    typography: {
        fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
        fontWeightRegular: 'bold',
        h1: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 700,
            color: '#212529', // Headings Color
        },
        h2: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 700,
            color: '#212529', // Headings Color
        },
        h3: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 700,
            color: '#212529', // Headings Color
        },
        h4: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            color: '#212529', // Headings Color
        },
        h5: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            color: '#212529', // Headings Color
        },
        h6: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            color: '#212529', // Headings Color
        },
        subtitle1: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 'bold',
            color: '#212529', // Body Text Color
        },
        subtitle2: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 'bold',
            color: '#212529', // Body Text Color
        },
        body1: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: '0.9rem',
            lineHeight: 1.5,
            fontWeight: 'bold',
            color: '#212529', // Body Text Color
        },
        body2: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: '0.875rem',
            lineHeight: 1.5,
            fontWeight: 'bold',
            color: '#212529', // Body Text Color
        },
        button: {
            fontFamily: '"Montserrat Classic", "Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 600,
            textTransform: 'none',
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiTooltip: {
            defaultProps: {
              enterTouchDelay: 0,
              leaveTouchDelay: 2500,
              disableTouchListener: false,
              disableHoverListener: false,
              disableFocusListener: false,
              PopperProps: {
                modifiers: [
                  {
                    name: 'preventOverflow',
                    enabled: true,
                    options: {
                      boundary: 'viewport',
                      padding: 8,
                    },
                  },
                  {
                    name: 'flip',
                    enabled: true,
                  },
                ],
              },
            },
            styleOverrides: {
              tooltip: {
                maxWidth: 220, // Ensures tooltip doesn't get too wide
              },
            },
          },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '8px 16px',
                    fontWeight: 600,
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
                    },
                },
                outlined: {
                    borderWidth: 2,
                    '&:hover': {
                        borderWidth: 2,
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#D1D5DB', // Content Border Color
                        },
                        '&:hover fieldset': {
                            borderColor: '#6C757D', // Alternate Text Color
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#ff4900', // Primary accent color
                        },
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF', // Content Background Color
                    borderRadius: 12,
                    boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #D1D5DB', // Content Border Color
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF', // Content Background Color
                    '--Paper-overlay': 'none !important', // Remove the default overlay globally
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF', // Content Background Color
                    color: '#212529', // Headings Color
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#ff4900', // Primary accent color
                    '&:hover': {
                        color: '#ff6933', // Primary light
                    },
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: '#d1d5db', // Main Divider Line Color
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 8,
                    border: '1px solid',
                    borderColor: '#D1D5DB', // Content Border Color
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#FFFFFF', // Content Background Color
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: 'rgba(255, 73, 0, 0.08)', // Primary color with opacity
                    },
                    '&.Mui-selected': {
                        backgroundColor: 'rgba(255, 73, 0, 0.12)', // Primary color with opacity
                        '&:hover': {
                            backgroundColor: 'rgba(255, 73, 0, 0.16)', // Primary color with opacity
                        },
                    },
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                paper: {
                    borderRadius: 8,
                    border: '1px solid',
                    borderColor: '#D1D5DB', // Content Border Color
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#FFFFFF', // Content Background Color
                },
                listbox: {
                    padding: '4px',
                    backgroundColor: '#FFFFFF', // Content Background Color
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: 'rgba(209, 213, 219, 0.1)',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(108, 117, 125, 0.4)',
                        borderRadius: '4px',
                        '&:hover': {
                            backgroundColor: 'rgba(108, 117, 125, 0.6)',
                        },
                    },
                },
                option: {
                    padding: '8px 10px',
                    borderRadius: '4px',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 73, 0, 0.08)', // Primary color with opacity
                    },
                    '&.Mui-focused': {
                        backgroundColor: 'rgba(255, 73, 0, 0.12)', // Primary color with opacity
                    },
                },
                popper: {
                    backgroundColor: '#FFFFFF', // Content Background Color
                },
            },
        },
    },
});

// Export both themes as named exports
export { darkTheme, lightTheme };

// Also export darkTheme as default for backwards compatibility
export default darkTheme;
